<mat-card class="palette-card">
  <mat-card-header>
    <mat-icon mat-card-avatar>widgets</mat-icon>
    <mat-card-title>{{ 'FORM_BUILDER.FIELD_PALETTE' | translate }}</mat-card-title>
    <mat-card-subtitle>{{ 'FORM_BUILDER.DRAG_HINT' | translate }}</mat-card-subtitle>
  </mat-card-header>
  
  <mat-card-content class="mt-4">
    <div class="field-type-list">
      <div
        *ngFor="let fieldType of fieldTypes"
        class="field-type-item"
        draggable="true"
        (dragstart)="onDragStart($event, fieldType)"
        (dragend)="onDragEnd($event)">
        
        <!-- Actual item -->
        <div class="field-type-content">
          <mat-icon class="field-icon">{{ fieldType.icon }}</mat-icon>
          <div class="field-info">
            <span class="field-label">{{ fieldType.label | translate }}</span>
            <span class="field-description">{{ fieldType.description | translate }}</span>
          </div>
          <mat-icon class="drag-handle">drag_indicator</mat-icon>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
